import { render, staticRenderFns } from "./monitors.page.vue?vue&type=template&id=b9d6fda0"
import script from "./monitors.page.vue?vue&type=script&lang=js"
export * from "./monitors.page.vue?vue&type=script&lang=js"
import style0 from "./monitors.page.vue?vue&type=style&index=0&id=b9d6fda0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports